<template>
  <div class="qr-code-container">
    <canvas ref="qrCanvas" :width="size" :height="size" />
    <div v-if="loading" class="qr-loading">
      <a-spin size="small" />
      <span>{{ $t('pages_wallet_031') || '生成二维码中...' }}</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import QRCode from 'qrcode'

export default {
  name: 'QrCode',
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 200
    },
    errorCorrectionLevel: {
      type: String,
      default: 'M',
      validator: value => ['L', 'M', 'Q', 'H'].includes(value)
    },
    color: {
      type: Object,
      default: () => ({
        dark: '#000000',
        light: '#FFFFFF'
      })
    }
  },
  setup(props) {
    const qrCanvas = ref(null)
    const loading = ref(false)

    const generateQRCode = async () => {
      if (!props.text || !qrCanvas.value) return

      loading.value = true
      try {
        const canvas = qrCanvas.value
        const options = {
          errorCorrectionLevel: props.errorCorrectionLevel,
          type: 'image/png',
          quality: 0.92,
          margin: 1,
          color: props.color,
          width: props.size
        }

        await QRCode.toCanvas(canvas, props.text, options)
      } catch (error) {
        console.error('Error generating QR code:', error)
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      generateQRCode()
    })

    watch([() => props.text, () => props.size, () => props.errorCorrectionLevel], generateQRCode)

    return {
      qrCanvas,
      loading
    }
  }
}
</script>

<style lang="less" scoped>
.qr-code-container {
  position: relative;
  display: inline-block;

  canvas {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: white;
  }

  .qr-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    font-size: 12px;
    color: #666;

    span {
      margin-top: 8px;
    }
  }
}
</style>
